import { Space } from 'src/utils/theme';
import { PickValues } from 'src/types/utility';

export type SupportedThemeSize = PickValues<
  Space,
  's6' | 's8' | 's10' | 's16' | 's20' | 's26' | 's32'
>;
export type LevelNumberBadgeSize = 'xs' | 's' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const badgeSizes: Record<LevelNumberBadgeSize, SupportedThemeSize> = {
  xs: 's6',
  s: 's8',
  sm: 's10',
  md: 's16',
  lg: 's20',
  xl: 's26',
  xxl: 's32',
};
